<template>
  <div>
    <HeadlineContainer headline="Create Project Category" :breadcrumbs="breadcrumbs"/>

    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Create Project Category
            </h3>

            <p>
              Enter the details of the project category.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the project category."
                    :error="getError('name')"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    HeadlineContainer,
    HelpText,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  data() {
    return {
      data: {},
    }
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/project-categories', text: 'Project Categories'},
        {text: 'Create'}
      ]
    },
  },

  methods: {
    submit() {
      http.post('/api/v2/project-categories', this.data)
          .then(() => {
            notify.success('The project category was saved')

            this.$router.push('/project-categories')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
